import React from 'react';
import { capitalize } from 'lodash-es';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ConfirmModal = ({ open, handleCancel, handleContinue, title, content, disabled, variant = 'delete', buttonText }) => (
    <Dialog open={open} fullWidth maxWidth={'sm'}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions>
            <Button onClick={handleCancel} variant="outlined">
                Cancel
            </Button>
            <Button onClick={handleContinue} color={variant === 'delete' ? 'error' : 'primary'} variant="contained" disabled={disabled}>
                {buttonText || capitalize(variant)}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmModal;
